import { useState, useEffect, Suspense, lazy } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Lazy Loaded Page Components
const HomePage = lazy(() => import("./components/HomePage").then(module => ({
  default: () => (
    <>
      <module.Hero />
      <module.About />
      <module.Projects />
      <module.Partners />
    </>
  )
})));

const AboutPage = lazy(() => import("./components/AboutPage").then(module => ({
  default: () => (
    <>
      <module.AboutUs />
      <module.VisionMission />
      {/* <module.PeopleBTS /> */}
    </>
  )
})));

const ServicesPage = lazy(() => import("./components/ServicesPage").then(module => ({
  default: () => (
    <>
      <module.Services />
      <module.List />
      <module.Installation />
      <module.Purification />
      <module.Sparepart />
    </>
  )
})));

const ProjectsPage = lazy(() => import("./components/ProjectsPage").then(module => ({
  default: () => (
    <>
      <module.ProjectsHero />
      <module.DevelopmentMap />
    </>
  )
})));

const FAQPage = lazy(() => import("./components/FAQPage").then(module => ({
  default: () => (
    <>
      <module.FAQSection />
    </>
  )
})));


// import { Hero, About, Projects, Partners } from "./components/HomePage";
// import { AboutUs, VisionMission } from "./components/AboutPage";
// import { Services, List, Installation, Purification, Sparepart } from "./components/ServicesPage"
// import { FAQSection } from "./components/FAQPage"
// import { DevelopmentMap, ProjectsHero } from "./components/ProjectsPage";

const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
  exit: { opacity: 0, y: -20, transition: { duration: 0.3 } }
};

// Skeleton Loader for Suspense
const PageLoader = () => (
  <div className="h-screen w-full bg-black flex items-center justify-center">
    <div className="flex flex-col items-center">
      <div className="w-12 h-12 border-4 border-red-600 border-t-transparent rounded-full animate-spin"></div>
      <p className="mt-4 text-zinc-500 font-lato tracking-widest uppercase text-xs">Loading...</p>
    </div>
  </div>
);

function AnimatedRoutes({ setMenuOpen }) {
  const location = useLocation();

  // Close menu whenever the path changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location, setMenuOpen]);

  return (
    <AnimatePresence mode="wait">
      <Suspense fallback={<PageLoader />}>
        <Routes location={location} key={location.pathname}>
          {/* Root Redirect */}
          <Route path="/" element={<Navigate to="/home" replace />} />

          {/* Dynamic Routes */}
          <Route path="/home" element={
            <motion.div variants={fadeInUp} initial="hidden" animate="show" exit="exit">
              <HomePage />
              <Footer />
            </motion.div>
          } />

          <Route path="/aboutus" element={
            <motion.div variants={fadeInUp} initial="hidden" animate="show" exit="exit">
              <AboutPage />
              <Footer />
            </motion.div>
          } />

          <Route path="/services" element={
            <motion.div variants={fadeInUp} initial="hidden" animate="show" exit="exit">
              <ServicesPage />
              <Footer />
            </motion.div>
          } />

          <Route path="/projects" element={
            <motion.div variants={fadeInUp} initial="hidden" animate="show" exit="exit">
              <ProjectsPage />
              <Footer />
            </motion.div>
          } />

          <Route path="/faq" element={
            <motion.div variants={fadeInUp} initial="hidden" animate="show" exit="exit">
              <FAQPage />
              <Footer />
            </motion.div>
          } />
        </Routes>
      </Suspense>
    </AnimatePresence>
  );

//   return (
//     <AnimatePresence mode="wait">
//       <Routes location={location} key={location.pathname}>

//         {/* Redirect root to /home */}
//         <Route path="/" element={<Navigate to="/home" replace />} />
        
//         {/* Home Page */}
//         <Route
//           path="/home"
//           element={
//             <>
//               <motion.div
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <Hero menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
//               </motion.div>

//               <div className="h-32 bg-gradient-to-b from-transparent to-black" />

//               <motion.div
//                 className="py-32"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <About />
//               </motion.div>

//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <Projects />
//               </motion.div>

//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <Partners />
//               </motion.div>

//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <Footer />
//               </motion.div>
//             </>
//           }
//         />

//         {/* About Us Page */}
//         <Route
//           path="/aboutus"
//           element={
//             <>
//               <motion.div
//                 className="py-0"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <AboutUs />
//               </motion.div>

//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <VisionMission />
//               </motion.div>

//               {/* <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <PeopleBTS />
//               </motion.div> */}

//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <Footer />
//               </motion.div>
//             </>
//           }
//         />

//         {/* Projects Page */}
//         <Route
//           path="/projects"
//           element={
//             <>
//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <ProjectsHero />
//               </motion.div>

//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <DevelopmentMap />
//               </motion.div>

//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <Footer />
//               </motion.div>
//             </>
//           }
//         />

//         {/* Services Page */}
//         <Route
//           path="/services"
//           element={
//             <>
//               <motion.div
//                 className="py-0"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <Services />
//               </motion.div>

//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <List />
//               </motion.div>

//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <Installation />
//               </motion.div>

//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <Purification />
//               </motion.div>

//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <Sparepart />
//               </motion.div>

//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <Footer />
//               </motion.div>
//             </>
//           }
//         />

//         {/* FAQ Page */}
//         <Route
//           path="/faq"
//           element={
//             <>
//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <FAQSection />
//               </motion.div>

//               <motion.div
//                 className="py-5"
//                 variants={fadeInUp}
//                 initial="hidden"
//                 animate="show"
//                 exit="hidden"
//               >
//                 <Footer />
//               </motion.div>
//             </>
//           }
//         />
//       </Routes>
//     </AnimatePresence>
//   );
}

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Prevent background scrolling when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [menuOpen]);

  return (
    <Router>
      <ScrollToTop />
      <div className="bg-black text-white relative">
        <Header menuOpen={() => setMenuOpen(setMenuOpen)} />
        <main>
          <AnimatedRoutes menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
        </main>
      </div>
    </Router>
  );
}

export default App;